import React from 'react';

import { styled } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { theme } from 'theme';

const variants = {
  primaryOpen: {
    backgroundColor: theme.colors.primary.red,
    color: theme.colors.primary.white,
  },
  primaryClosed: {
    backgroundColor: theme.colors.primary.grey,
    color: theme.colors.primary.white,
  },
  secondary: {
    backgroundColor: theme.colors.primary.white,
    color: theme.colors.primary.grey,
  },
};

const ExpandIcon = styled(ExpandMoreIcon)(({ variant = 'primaryClosed' }) => ({
  borderRadius: '3px',
  ...variants[variant],
}));

const CustomExpandIcon = ({ ...props }) => {
  return <ExpandIcon {...props} />;
};

export default CustomExpandIcon;
